import styled from 'styled-components';
import { spacing } from 'ui/theme';

// x8 creates three column layout (if three items), if two is preferred use x12
export const FlexContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(${spacing.x8}, 1fr));
  gap: ${spacing.half} ${spacing.plusHalf};
`;
